module.exports = __webpack_public_path__ + "img/lp-logo@2x.f4c03b32.webp";